import { useParams } from 'react-router-dom'

import { QuoteDetailDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import QuoteDetail from 'modules/finance/components/Quotes/QuotesDetail'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const QuoteDetailPage = () => {
  const { quoteId } = useParams()

  const { company } = useCurrentSession()

  const { data, error, loading } = useQuery(QuoteDetailDocument, {
    variables: {
      companyId: company.id,
      id: String(quoteId),
    },
    skip: !quoteId,
  })

  const quote = data?.finance?.quotes[0]
  const authorized = data?.finance?.quotes[0]?._policies?.access.can

  return (
    <ResponsivePage.Body
      variant="fullscreen"
      loading={loading}
      error={error}
      authorized={authorized}
    >
      {quote && <QuoteDetail quote={quote} />}
    </ResponsivePage.Body>
  )
}

export default QuoteDetailPage
